import { ApiResponse } from "../../../types";
import { OtpPayload, OtpResponse, ResendOtp } from "../../../types/login.types";
import { postRequest ,patchRequest} from "../configuration";
import getApiWithVersion from "../apis";
import { API_VERSION } from "../../constants/common";
const api = getApiWithVersion(API_VERSION.V2);
export interface Auth{
    postResendOtp(data:ResendOtp):Promise<ApiResponse<OtpResponse>>;
    patchOtpExpire(data:ResendOtp):Promise<ApiResponse<OtpResponse>>;
   
}

const auth: Auth = {
    postResendOtp(data) {
        return postRequest(api.RESEND_OTP, data)
    },

    patchOtpExpire(data){
        return patchRequest(api.RESEND_OTP_EXPIRE, data)
    }
   
}

export default auth

